import { render, staticRenderFns } from "./ReleaseNotes.html?vue&type=template&id=651843c1&scoped=true&external"
import script from "./ReleaseNotes.ts?vue&type=script&lang=ts&external"
export * from "./ReleaseNotes.ts?vue&type=script&lang=ts&external"
import style0 from "./ReleaseNotes.scss?vue&type=style&index=0&id=651843c1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651843c1",
  null
  
)

export default component.exports